module.exports = __webpack_public_path__ + "img/泽泻.5ca65a7e.jpg";